import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { BusinessSummaryResponseDTO } from 'src/app/shared/models/dtos/responses/business-summary-response-dto/business-summary-response-dto';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { BusinessStatus } from 'src/app/shared/models/constants/business-status';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'app-business-basic-details',
  templateUrl: './business-basic-details.component.html',
  styleUrls: ['./business-basic-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Shows basic infos about a business
 */
export class BusinessBasicDetailsComponent implements OnInit, OnChanges {
  @Input() businessSummary?: BusinessSummaryResponseDTO;
  @Input() nRepresentative!: number;
  @Input() resellerName?: string | null;
  @Output() nRepChanges = new EventEmitter<any>();
  @Output() businessDataChanged = new EventEmitter<void>();
  viewOnly!: boolean;
  global!: boolean;
  businessDisabled: boolean = false;
  today = new Date().toISOString();

  readonly labels = {
    disabledBusinessMessage: 'disabled-business-message-global',
  };

  /**
   * @constructor
   */
  constructor(
    private dialogService: DialogService,
    private authenticatedUserService: AuthenticatedUserService,
    private translationService: TranslationService
  ) {}

  /**
   * on init
   */
  ngOnInit(): void {
    this.viewOnly = this.authenticatedUserService.isVOAdmin();
    this.global = this.authenticatedUserService.isGlobalAdmin();
    this.businessDisabled = this.isDisabled();
    this.translationService.translateObject(this.labels);
    this.today = this.translationService.localizeDate(this.today);
  }

  /**
   * on changes
   * @param {SimpleChanges} changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['nRepresentative']) {
      this.businessDisabled = this.isDisabled();
    }
  }

  /**
   * Shows business editting modal
   */
  async openEditBusinessModal() {
    this.dialogService.openEditBusinessModal(
      this.businessSummary!,
      this.reloadBusinessData
    );
  }

  /**
   * Reloads business summary after modal is closed with a successful update
   * @param {any} data
   */
  private reloadBusinessData = (data: any) => {
    if (data) {
      this.businessSummary!.picture = data?.imgSource;
      this.businessSummary!.name = data?.businessName;
      this.businessSummary!.address = data?.address;
      this.businessSummary!.postalCode = data?.postalCode;
      this.businessSummary!.addressNumber = data?.addressNumber;
      this.businessSummary!.state = data?.state;
      this.businessSummary!.email = data?.email;
      this.businessSummary!.country = data?.country;
      this.businessSummary!.businessType = data?.businessType;
      this.businessSummary!.phoneNumber = data?.phoneNumber;
      this.businessSummary!.website = data?.website;

      this.businessDataChanged.emit();
    }
  };

  /**
   * Checks is business is disabled
   * @return {boolean}
   */
  isDisabled(): boolean {
    const isBusinessDisabled =
      this.businessSummary?.status === BusinessStatus.DISABLED;
    const hasNoRepresentatives = this.nRepresentative === 0;

    return isBusinessDisabled && hasNoRepresentatives;
  }
}
